import { useTranslation } from 'react-i18next';

const OrderHistory = () => {
  const { t } = useTranslation();

  return <div className="order-history">{t('header.orderHistory')}</div>;
};

export default OrderHistory;
